import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requestConfig from 'app/requests/RateCard/RateCard.requests'

const useGetCountryEmbargo = (countryId: number) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useRequest<{ embargoed: boolean }>({
        key: RequestKeys.getCountryEmbargo,
        params: {
            countryId,
        },
        requestFunc: RequestFn.getEntity(requestConfig.embargoCountriesGetCountryEmbargo),
        enabled: Boolean(countryId),
    })

    return {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    }
}

export default useGetCountryEmbargo
